module.exports = __webpack_public_path__ + "static/web_agency-9dcf5792775eceb3bc7db2e8cae82742.svg";